import React, { useState, useEffect } from "react";
import Select from "react-select";
import CustomSelectOption from "../customSelectOption/CustomSelectOption";
import CustomSelectLabel from "../customSelectLabel/CustomSelectLabel";
import http from "../../../shared/http-request";
import { BASE_URL } from "../../../StaticArray/StaticArray";
import { useTranslation } from "react-i18next";
import "../../../translations/i18n";
import {
  onAudienceInterestSuggestion,
  onAudienceSearchInterest,
} from "../../../utils/network/lib/audience";

const FbExcludeAudience = ({
  getSelectValue,
  onSelectChange,
  selectStyles,
  audienceListOptions,
  interestsList,
  audienceData,
}) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState(false);

  const [options, setOptions] = useState([]);
  const [fbExcludeAudienceSuggestions, setFbExcludeAudienceSuggestions] =
    useState([]);

  useEffect(() => {
    let selectedData = getSelectValue("exclude");
    if (selectedData && selectedData.length > 0) {
      onSelectValue(selectedData);
    }
  }, [audienceListOptions]);

  useEffect(() => {
    if (
      audienceListOptions.length > 0 &&
      fbExcludeAudienceSuggestions.length === 0
    ) {
      setOptions(interestsList);
      const element = document.getElementById("fb_select2");
      element.firstChild.addEventListener("click", () => setFocus(true));
    }
    const fb_select1 = document.getElementById("fb_select2");
    const element = document.getElementById("selectpostpopup__container");
    element.addEventListener("click", (e) => {
      if (fb_select1.contains(e.target)) {
        setFocus(true);
      } else {
        setFocus(false);
        if (fbExcludeAudienceSuggestions.length === 0) {
          setOptions(interestsList);
        } else {
          setOptions(fbExcludeAudienceSuggestions);
        }
      }
    });
  }, [interestsList, audienceListOptions, fbExcludeAudienceSuggestions]);

  let timer = 500;

  const onInputChange = (query) => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      if (query.length === 0) return;
      const res = await onAudienceSearchInterest({
        params: {
          q: query,
        },
      });
      if (res.status === 200) {
        let array = [];
        res.data.data.map((interest) => {
          const object = {};
          const values = interest.value.split("|");
          object.value = values[0];
          // object.label = values[1];
          values.length > 2
            ? (object.label = values[1] + "|" + values[2])
            : (object.label = values[1]);
          array = [...array, object];
        });
        setFocus(true);
        setOptions(array);
      }
    }, 500);
  };

  const onSelectValue = async (selectedValuesOption) => {
    if (selectedValuesOption == null) {
      setOptions(interestsList);
      setFbExcludeAudienceSuggestions([]);
      return;
    }
    let query = [];

    selectedValuesOption.map((param) => {
      query.push({ type: "interests", id: parseInt(param.value) });
    });

    if (query.length === 0) return;
    await onAudienceInterestSuggestion({
      params: {
        q: query,
      },
    }).then((res) => {
      if (res.status === 200) {
        let array = [];
        res.data.data.map((interest) => {
          const object = {};
          const values = interest.value.split("|");
          object.value = values[0];
          // object.label = values[1];
          values.length > 2
            ? (object.label = values[1] + "|" + values[2])
            : (object.label = values[1]);
          object.type = interest.type;
          array = [...array, object];
        });
        setFbExcludeAudienceSuggestions(array);
        setOptions(array);
      }
    });
  };

  return (
    <div style={{ marginTop: "40px" }} className="fbincludeaudience__container">
      <div className="fbincludeaudience__heading--container">
        <div className="fbincludeaudience__heading">
          <img
            src="/images/facebook_1facebook.png"
            className="fbincludeaudience-fb-icon"
            alt=""
          />
          {t("excludeAudience")}
        </div>
        <div>
          <span
            onClick={() => {
              setOptions(audienceListOptions);
              setFocus(true);
            }}
          >
            {t("savedAudience")}
            <img
              className="fbincludeaudience__img--arrow"
              src="/images/media-projection.png"
              alt=""
            />
          </span>
        </div>
      </div>
      <Select
        id="fb_select2"
        isMulti
        menuIsOpen={focus}
        options={options}
        components={{
          Option: (optionProps) => (
            <CustomSelectOption
              {...optionProps}
              audienceData={audienceData}
              parentComponent="fbExclude"
            />
          ),
          MultiValueLabel: (labelProps) => (
            <CustomSelectLabel {...labelProps} />
          ),
        }}
        className="fbincludeaudience__input--select"
        placeholder={t("excludeAudiencePlaceHolder")}
        value={getSelectValue("exclude")}
        onChange={(e) => {
          setOptions(interestsList);
          setFocus(false);
          onSelectChange("exclude", e);
          onSelectValue(e);
        }}
        onBlur={() => setFocus(false)}
        onInputChange={(e) => onInputChange(e)}
        styles={selectStyles}
      />

      <p className="fbincludeaudience__para">{t("excludeAudiencePara")}</p>
    </div>
  );
};

export default FbExcludeAudience;
